import React from "react";
import { useNavigate } from "react-router-dom";

import HomeFilledIcon from "@mui/icons-material/HomeFilled";
import "./HomeButton.css";
function HomeButton() {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate("/")} className="home-button">
      <HomeFilledIcon />
    </div>
  );
}

export default HomeButton;
